import { Separator } from '@radix-ui/themes';
import { ErrorBoundary } from 'components/common/error-boundary';
import { SettingForm } from 'components/common/settings-dialog/form';
import { InactiveCallout } from 'components/common/settings-dialog/inactive-callout';
import { AccessoriesSectionAutoForm } from 'components/common/settings-dialog/main-sections/accessories-section/auto-form';
import { AccessoriesSectionManualForm } from 'components/common/settings-dialog/main-sections/accessories-section/manual-form';
import { MachineContext } from 'contexts/machine.context';
import { useContext, useEffect, useState } from 'react';

export const AccessoriesSection = () => {
  const { isActive } = useContext(MachineContext);

  // show the key code of whatever was last pressed
  const [lastKey, setLastKey] = useState('');

  // for manual inputs
  const [manual, setManual] = useState(false);

  // for key listener
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    setPaused(!manual);
  }, [manual]);

  return (
    <ErrorBoundary identifier="AccessoriesSection">
      <SettingForm>
        {!isActive && <InactiveCallout />}

        <AccessoriesSectionAutoForm
          manual={manual}
          paused={paused}
          lastKey={lastKey}
          onChangeLastKey={setLastKey}
        />
        <Separator size="4" />
        <AccessoriesSectionManualForm
          paused={paused}
          onTogglePaused={setPaused}
          manual={manual}
          onToggleManual={setManual}
          lastKey={lastKey}
        />
      </SettingForm>
    </ErrorBoundary>
  );
};
